import { NgModule } from '@angular/core';
import { RequiredFieldsNoteDirective } from './required-fields-note.directive';
import { RequiredFieldsNoteComponent } from './required-fields-note.component';

@NgModule({
	imports: [
		RequiredFieldsNoteDirective,
		RequiredFieldsNoteComponent
	],
	exports: [
		RequiredFieldsNoteDirective,
		RequiredFieldsNoteComponent
	]
})
export class RequiredFieldsNoteModule {}
